module.exports = __webpack_public_path__ + "static/img/step4.7c47a93f.png";